import { useEffect, useRef, useState } from 'react';
import { FaArrowLeft, FaArrowRight } from 'react-icons/fa';
import { SideBarItem } from './FormSideBarItem/FormSideBarItem';
import { formPathToFormName } from '../../../data/constants/constants';
import './FormSideBar.css';
import { deviceType, osName } from 'react-device-detect';
import { useLocation, useSearchParams } from 'react-router-dom';
import { getLocation } from '../../../utils/location';
import { getCookie } from '../../../utils/cookies';
import { useSelector } from 'react-redux';
import { RootState } from '../../../redux/store';
import { FrontendEventProps } from 'api/models/payload/EventsPayload';
import api from 'api';

interface Props {
    screen: number;
    formPath: string[];
    filledForms?: string[];
    serviceProviderForms?: boolean;
}

const country: string = getLocation().userCountry;
const sessionId = getCookie('JSESSIONID');

const FormSideBar = ({ screen, formPath, filledForms, serviceProviderForms }: Props) => {
    const [shownPathTitle, setShownPathTitle] = useState(screen);
    const user = useSelector((state: RootState) => state.user.entity);
    const scrollRef = useRef<HTMLDivElement>(null);
    const [queryParameters] = useSearchParams();
    const location = useLocation();

    const handleSideBarItemNavigation = async (origin: string, destination: string) => {
        const url = location.pathname + `/${currentForm.toLowerCase().replace(' ', '_')}`;
        const url_params = window.document.referrer
            ? new URL(window.document.referrer).searchParams
            : null;
        const _eventParams: FrontendEventProps = {
            page_title: url,
            page_url: url,
            os_type: osName,
            country: country,
            user_id: `${user.id}`,
            session_id: sessionId,
            device_type: deviceType,
            referrer: window.document.referrer,
            user_agent: window.navigator.userAgent,
            utm_source: queryParameters.get('utm_source') || url_params?.get('utm_source') || '',
            utm_medium: queryParameters.get('utm_medium') || url_params?.get('utm_medium') || '',
            utm_campaign:
                queryParameters.get('utm_campaign') || url_params?.get('utm_campaign') || '',
            utm_content: queryParameters.get('utm_content') || url_params?.get('utm_content') || '',
            anonymousId: localStorage.ajs_anonymous_id?.replaceAll('"', ''),
        };
        const eventName = 'section_nav';
        const res = await api.events.frontend_event_post(eventName, _eventParams);
        if (res.status !== 200 && res.status !== 201) {
            console.log(res.statusText);
        }
    };

    // todo: remake it with MUI
    const shownPreviousPathTitle = () => {
        if (shownPathTitle >= 2) {
            // dispatch(set(shownPathTitle - 1));
            setShownPathTitle(shownPathTitle - 1);
        }
    };

    const shownNextPathTitle = () => {
        if (shownPathTitle <= formPath.length - 1) {
            // dispatch(set(shownPathTitle + 1));
            setShownPathTitle(shownPathTitle + 1);
        }
    };

    const moveScrollTo = (scrollOffset: number) => {
        if (scrollRef.current) {
            scrollRef.current.scrollLeft = (screen - 1) * scrollOffset;
        }
    };

    const isFormFilled = (formName: string): boolean => {
        if (!filledForms) {
            return false;
        }
        return filledForms.includes(formPathToFormName[formName]);
    };

    const currentForm = formPath[screen - 1];

    useEffect(() => {
        moveScrollTo(300);
        // eslint-disable-next-line
    }, [screen]);

    return (
        <div className={'formSideBarWrapper'}>
            <div className="formSideBarBody" ref={scrollRef}>
                {formPath.map((value, index) => (
                    <SideBarItem
                        isPathTitleShown={formPath[shownPathTitle - 1] === value}
                        handleSideBarItemNavigation={handleSideBarItemNavigation}
                        isFormFilled={isFormFilled(value)}
                        serviceProviderForms={serviceProviderForms}
                        currentForm={currentForm}
                        formPath={formPath}
                        formName={value}
                        key={index}
                        id={index}
                    />
                ))}
            </div>
            <div className="scroll-container">
                <button className="scroll-btn-left" onClick={() => shownPreviousPathTitle()}>
                    <FaArrowLeft />
                </button>
                <button className="scroll-btn-right" onClick={() => shownNextPathTitle()}>
                    <FaArrowRight />
                </button>
            </div>
        </div>
    );
};

export default FormSideBar;
